import { Checkbox, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { useEffect, useState } from "react"
import "./RoleSelector.css"
import UserAssignment from "../../models/userAssignments.interface"

function RoleSelector(props: any) {

    const [selectedRole, setSelectedRole] = useState("")
    const roles = props.roles
    const assignment: UserAssignment = props.assignment

    const handleRoleChange = (event: SelectChangeEvent) => {
        setSelectedRole(event.target.value)
    }

    useEffect(() => {
        props.selectedRole(selectedRole)
    }, [selectedRole])

    useEffect(() => {
        setSelectedRole("")
    }, [assignment])

    return(
        <div className="RoleSelector"> 
            <FormControl sx={{ m: 0 }}>
                <Select
                sx= {{ fontSize: "1em", borderRadius: "50px", padding: "5px"}}
                value={selectedRole}
                onChange={handleRoleChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                className="RoleSelector-select-container"
                >
                    <MenuItem value="">
                        <em>All Roles</em>
                    </MenuItem>
                    {roles.map((role: string) => {
                        return(
                            <MenuItem value={role}> {role} </MenuItem>
                        )
                        })}
                </Select>
            </FormControl>
        </div>
    )
}
export default RoleSelector